export const THEME_KEY = "crialume:theme";

/** Same initial preference as index.html, so bootstrap never resets the first paint. */
export function readTheme(): "light" | "dark" {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* Storage may be unavailable in restricted browser sessions. */
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
